import React from "react";
import Icon from "../../Icon";
import { ICON_TYPE_TOOLTIP } from "../../Icon/constants";
import Tooltip from "../../Tooltip";
import { getClassNames } from "../../../utils";

type CellTooltipedProps = {
    value?: string | null;
    maxLength?: number;
};

function CellTooltiped(
    props: CellTooltipedProps = {
        value: null,
        maxLength: 20,
    }
) {
    const value = props.value ?? "";
    const maxLength = props.maxLength ?? 20;
    const showTooltip = value.length > maxLength;
    const className = getClassNames("table-cell_tooltipped", {
        "table-cell_tooltipped-show": showTooltip,
    });

    const trimmedValue =
        value.length > maxLength
            ? `${value.substring(0, maxLength)}...`
            : value;

    return (
        <span className={className}>
            <span>{trimmedValue}</span>
            {showTooltip && (
                <Tooltip
                    title={value}
                    className="table-tooltip"
                    trigger="click"
                >
                    <Icon
                        className="icon__tooltipped"
                        size={10}
                        type={ICON_TYPE_TOOLTIP}
                    />
                </Tooltip>
            )}
        </span>
    );
}


export default CellTooltiped;
